import * as React from 'react';

export class DettaglioCliente extends React.Component {
    
    render(){
        return ( 
            <div>
                <div className='ms-font-m-plus'><b>{this.props.RAGSOC}</b></div>
                <div className='ms-font-xs'>{this.props.INDIRIZZO}</div>
            </div>
        );
    }
}

export default DettaglioCliente;


// WEBPACK FOOTER //
// ./src/AcComponents/DettaglioCliente.js